import enGB from "date-fns/locale/en-GB";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";
import it from "date-fns/locale/it";

export const getDateFnsLocale = (): any => {
  const language = localStorage.getItem("i18nextLng");

  switch (language) {
    case "en":
      return enGB;
    case "de":
      return de;
    case "fr":
      return fr;
    case "it":
      return it;
    default:
      return enGB;
  }
};
